import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { RecordShell } from "@/components/records/RecordShell";

const TYPES = [["none", "No plan"], ["iep", "IEP"], ["504", "504 plan"], ["other", "Other support plan"]];

export default function Accommodations() {
  const { studentId } = useParams();
  const { profile } = useProfile();
  const [opts, setOpts] = useState({});
  const [f, setF] = useState(null);
  const edit = ["teacher", "parent", "admin"].includes(profile?.role);
  useEffect(() => {
    http.get("/accommodations/options").then((r) => setOpts(r.data));
    http.get(`/students/${studentId}/accommodations`).then((r) => setF({ ...r.data, notes: r.data.notes || "", review_date: r.data.review_date || "" }));
  }, [studentId]);
  if (!f) return <div className="py-20 text-center text-stone-500">Loading…</div>;
  const toggle = (k) => setF({ ...f, items: f.items.includes(k) ? f.items.filter((x) => x !== k) : [...f.items, k] });
  const save = async () => {
    try { const r = await http.put(`/students/${studentId}/accommodations`, { plan_type: f.plan_type, items: f.items, notes: f.notes, review_date: f.review_date || null }); setF({ ...f, ...r.data }); toast.success("Accommodations saved. Lessons and the buddy will adapt."); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <RecordShell title="Accommodations Plan" back testId="accommodations-page">
      <p className="mt-6 text-sm text-stone-600">IEP / 504 supports. Saved supports are applied automatically to AI lessons and the Learning Buddy.</p>
      <div className="mt-5 flex flex-wrap gap-2" data-testid="acc-type">
        {TYPES.map(([k, l]) => <button key={k} disabled={!edit} onClick={() => setF({ ...f, plan_type: k })} data-testid={`acc-type-${k}`} className={`px-4 py-2 rounded-full text-sm border ${f.plan_type === k ? "bg-[#2C4A3E] text-white border-[#2C4A3E]" : "bg-white border-[#E6DEC3]"}`}>{l}</button>)}
      </div>
      <div className="mt-6 grid sm:grid-cols-2 gap-2" data-testid="acc-items">
        {Object.entries(opts).map(([k, l]) => (
          <label key={k} className={`flex items-center gap-3 rounded-2xl border px-4 py-3 text-sm ${f.items.includes(k) ? "border-[#6B9080] bg-[#E3EBE5]" : "border-[#E6DEC3] bg-white"}`}>
            <input type="checkbox" disabled={!edit} checked={f.items.includes(k)} onChange={() => toggle(k)} data-testid={`acc-item-${k}`} className="accent-[#2C4A3E]" /> {l}
          </label>
        ))}
      </div>
      <textarea disabled={!edit} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} placeholder="Notes (goals, setting, who to contact)" maxLength={1000} data-testid="acc-notes" className="mt-5 w-full h-24 px-4 py-3 rounded-2xl bg-white border border-[#E6DEC3] text-sm" />
      <label className="mt-4 flex items-center gap-3 text-sm">Next review date <input type="date" disabled={!edit} value={f.review_date} onChange={(e) => setF({ ...f, review_date: e.target.value })} data-testid="acc-review-date" className="px-3 py-2 rounded-xl border border-[#E6DEC3]" /></label>
      {f.updated_by && <p className="mt-3 text-xs text-stone-500" data-testid="acc-updated">Last updated by {f.updated_by} on {f.updated_at.slice(0, 10)}</p>}
      {edit && <button onClick={save} data-testid="acc-save-btn" className="mt-6 px-6 py-2.5 rounded-full bg-[#C87D53] text-white text-sm no-print">Save plan</button>}
    </RecordShell>
  );
}
